module.exports = __webpack_public_path__ + "img/refresh.98b2e7d9.svg";